import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'tooltip-message',
	templateUrl: './tooltip-message.component.html',
	styleUrls: ['./tooltip-message.component.scss']
})

export class tooltipMessageComponent implements OnInit{

	@Input() tooltipMessage: boolean | undefined;
	@Input() validatorMessage: boolean | undefined;
	@Input() controls: any;
	@Input() label: any;
	@Input() submitted: boolean | undefined;


	constructor() { }

	ngOnInit() {

	}

}
